import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", [
      "isAdmin",
      "isSuperAdmin",
      "isBulkUploadAdmin",
      "isNbnEeAdmin",
      "rolesResolved",
      "user",
      "isUserMember"
    ]),
    ...mapGetters("order", [
      "locationID",
      "addressQueryResult",
      "formattedSQResult",
      "sqResult",
      "selectedOrder",
      "ntdDetails",
      "supportingResources",
      "nfas",
      "customizedOfferResult",
      "optusOrderDetails",
      "hasNtd",
      "unidPorts",
      "wholesalers",
      "sq5gResult",
      "sqNbnResult",
      "orderType",
      "hasSectorID",
      "msnList",
      "msnVal",
      "simList",
      "sim",
      "ratePlans5G",
      "ubCustomers",
      "isOriginal",
      "editForm",
      "hasFreePort",
      "isPendingServiceability",
      "isReferenceInvalid",
      "hasActiveServices",
      "isLayer3",
      "isHistoricalOrder",
      "radiusUserNameResults",
      "isOldOrder",
      "isDuplicate",
      "showFibreCheckbox",
      "transferredDate",
      "isInternalWholesaler",
      "reportData"
    ]),
    ...mapGetters("address", [
      "addressResults",
      "fullAddress",
      "searchResultId",
      "predictedAddresses"
    ]),
    ...mapGetters("appointment", [
      "availableSlots",
      "appointments",
      "appointmentSearch"
    ]),
    ...mapGetters("processLoader", ["isProcessingActive"]),
    ...mapGetters("httpResponse", ["httpText", "httpColor", "httpIsActive"]),
    ...mapGetters("impersonate", ["impersonating"]),
    ...mapGetters("featureFlag", ["featureFlags"]),
    ...mapGetters("product", [
      "excludedProducts",
      "isProductExcluded",
      "nbnOrder",
      "nbnOrderRecord",
      "orderAttachments",
      "orderBandwidth",
      "auditLogs",
      "isNoChange"
    ]),
    ...mapGetters("announcement", ["announcements", "hasAnnouncement"]),
    canBulkUpload() {
      return this.rolesResolved && this.isBulkUploadAdmin;
    }
  },
  methods: {
    ...mapActions("featureFlag", ["setFlags"]),
    ...mapActions("auth", [
      "setRoles",
      "markRolesResolved",
      "checkUser",
      "isImpersonatedAdmin"
    ]),
    ...mapActions("order", [
      "getNBNOrders",
      "addressQuery",
      "setLocationID",
      "setSelectedOrder",
      "serviceQualification",
      "createNewOrder",
      "createTemplatedEmail",
      "serviceOffer",
      "setAddressQueryResult",
      "setFormattedSQResult",
      "setFormattedNbnSQResult",
      "resetFormattedSQResult",
      "createCustomisedOffer",
      "getOrderDetails",
      "resetHasNtd",
      "setCustomizedOffer",
      "updateCustomizedOffer",
      "getWholesalers",
      "setEnhancedSq",
      "serviceQualification5G",
      "serviceQualificationNbn",
      "enhanceServiceQualificationNbn",
      "nbnAddressQuery",
      "reset5gSq",
      "setOrderType",
      "submit5GOrder",
      "getCustomerRefs",
      "getCustomerRefs5G",
      "getMsnList",
      "getSimList",
      "get5GOrderDetails",
      "resetHasSectorId",
      "get5gRatePlans",
      "updateOfferContact",
      "getUBCustomers",
      "setOriginal",
      "setEditForm",
      "setSqResult",
      "set5gSqResult",
      "set5gRatePlans",
      "setSimList",
      "setMsnList",
      "setUbCustomers",
      "getRequestData",
      "getSqResponse",
      "getFeatures",
      "resetFeature",
      "checkRadiusUsername",
      "createRadiusAccount",
      "getNbnConnectOrders",
      "updateOnIseekValue",
      "resetFormattedSqNbnResult",
      "submitServiceTest",
      "getServiceTestResult",
      "setReferenceInvalid",
      "getExportableNbnOrders",
      "sendAvailableSimEmail",
      "searchRadiusUsernames",
      "getRadiusPassword",
      "checkHardwareModem",
      "resetRadiusUsernameResults",
      "getServiceRadiusStatus",
      "getCvcIds",
      "removeServiceFromUsherAsync",
      "setOldOrder",
      "setIsDuplicate",
      "getStaticIp",
      "getMigrationResult",
      "setFibreCheckbox",
      "GetTransferredDate",
      "ReverseTransferService",
      "setUserInternal",
      "mapBandwidthProfile"
    ]),
    ...mapActions("appointment", [
      "setAppointmentSearch",
      "setAppointment",
      "updateAppointment",
      "checkAvailableSlots",
      "checkNbnAvailableSlots",
      "createNbnAppointment",
      "getAppointments",
      "getAppointmentDetails",
      "getNbnAppointments",
      "getNbnAppointment",
      "cancelNbnAppointment",
      "updateNbnAppointment",
      "checkNbnAllAvailableSlots"
    ]),
    ...mapActions("address", [
      "searchAddress",
      "getFullAddress",
      "getOrderAddress",
      "createTemplatedEmail",
      "createSupportTicket",
      "resetFullAddress",
      "setSearchResultId",
      "setAddressResult",
      "resetAddressResults",
      "getPredictAddresses",
      "getVerifiedAddressDetail",
      "setPredictedAddress"
    ]),
    ...mapActions("processLoader", ["setProcessActive", "setProcessInactive"]),
    ...mapActions("httpResponse", ["setHttpResponse", "resetHttpResponse"]),
    ...mapMutations("address", ["SET_ADDRESS_RESULTS"]),
    ...mapActions("impersonate", [
      "setImpersonate",
      "getImpersonate",
      "removeImpersonate"
    ]),
    ...mapActions("product", [
      "saveProduct",
      "getExcludedProducts",
      "productQualification",
      "resetProduct",
      "createNbnOrderAsync",
      "bulkImportExistingOrderAsync",
      "uploadFiles",
      "getFiles",
      "getFile",
      "createOrganisationAsync",
      "updateOrganisationAsync",
      "getOrganisationsAsync",
      "searchOrganisationsAsync",
      "createQuoteAsync",
      "updateQuoteAsync",
      "getQuotesAsync",
      "getQuoteAsync",
      "activateHoldOrderAsync",
      "cancelNbnOrderAsync",
      "disconnectNbnServiceAsync",
      "updateNbnOrderAsync",
      "correctNbnOrderAsync",
      "diagnoseNbnOrderSpeedChangeAsync",
      "repairNbnOrderSpeedChangeAsync",
      "getServiceRadiusAuthDetails",
      "setNbnOrderDetails",
      "resetNbnOrderDetails",
      "setProductType",
      "resetProductType",
      "setNtdId",
      "resetNtdId",
      "setNtdType",
      "resetNtdType",
      "resetNtdModification",
      "setCpiId",
      "resetCpiId",
      "resetExistingRadiusDetails",
      "resetNewRadiusDetails",
      "setNbnOrderType",
      "resetNbnOrderType",
      "setIsFibreConnect",
      "setNtdIdOrderItem",
      "setExistingNtdId",
      "setInstallationWorkforce",
      "resetInstallationWorkforce",
      "retrieveOrderBandwidth",
      "retrieveAuditLogs",
      "retrieveTagDetails",
      "setNtdModificationWithContext",
      "setNtdModifications",
      "setNtdTypeFromForm"
    ]),
    ...mapActions("ticket", [
      "createNewTicket",
      "getTickets",
      "getTicket",
      "addTicketNote",
      "amendTroubleTicket"
    ]),
    ...mapActions("announcement", ["getAnnouncements", "upsertAnnouncement"])
  }
};
